//#region [IMPORT]

import { keyframes } from '@mui/system';

//#endregion

const regex_start_of_word = /((?<=[a-z])[A-Z]|[A-Z](?=[a-z]))/g;

//-----------------------------------------------------------------
function spaceBeforeWord(match, p1, offset, string) {
  //-----------------------------------------------------------------
  return (offset > 0 ? " " : "") + match;
}
  
//-----------------------------------------------------------------
function toBoolean(str) {
  //-----------------------------------------------------------------
  if( str === true ) return true;
  const enabled = ['1', 'true', 'yes', 'ja', 'on'];
  return str && enabled.includes(str.toLowerCase());
}

//-----------------------------------------------------------------
function getProkeyUrl() {
  //-----------------------------------------------------------------
  const { origin } = window.location;
  if ( !origin ) return './';

  return origin +  '/prokeyweb/';
}

//#region [red]

const confirm = keyframes`
  from {
    background-color: green;
  }
  to {
    background-color: inherit;
  }
`;

const reject = keyframes`
  from {
    background-color: red;
  }
  to {
    background-color: inherit;
  }
`;

const _keyframes = {
  confirm,
  reject,
}

//#endregion

export { regex_start_of_word, spaceBeforeWord, toBoolean, getProkeyUrl, _keyframes as keyframes }